<template>
  <div>
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    ></div>
    <!--end::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin" style="min-width: 350px" >
      <div class="text-center mb-10 mb-lg-20">
        <h3 class="font-size-h1">Liste des pharmacies</h3>
      </div>

      <!--begin::Form-->
      <div class="card card-custom card-stretch gutter-b" id="page">
        <div class="card-header border-0 pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Selectionner une pharmacies</span
            >
            <span class="text-muted mt-3 font-weight-bold font-size-sm"
              >{{ pharmacies.length }} Pharmacie(s)</span
            >
          </h3>
        </div>
        <!--begin::Body-->
        <div class="card-body pt-8">
          <!--begin::Item-->
          <div
            class="d-flex align-items-center mb-10"
            v-for="pharmacy in pharmacies"
            :key="pharmacy.guid"
          >
            <!--begin::Symbol-->
            <div class="symbol symbol-40 symbol-light-success mr-5">
              <span class="symbol-label">
                <span class="svg-icon svg-icon-lg svg-icon-success">
                  <i class="fas fa-building text-success"></i>
                </span>
              </span>
            </div>
            <!--end::Symbol-->
            <!--begin::Text-->
            <div class="d-flex flex-column font-weight-bold">
              <button
                type="button"
                class="text-dark text-hover-primary mb-1 font-size-lg"
                @click="select(pharmacy)"
              >
                {{ pharmacy.name }}
              </button>
            </div>
            <!--end::Text-->
          </div>

          <!--end::Item-->
        </div>
        <!--end::Body-->
        <button
          class="btn btn-primary font-weight-bold font-size-2"
          @click="onLogout()"
        >
          Se déconnecter
        </button>
      </div>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { SELECT_PHARMACY } from "../../../core/services/store/pharmacy.module";
import { LOGOUT } from "@/core/services/store/auth.module";
import PharmacyService from "../../../services/pharmacies.service";
import loaderHelper from "../../../helpers/loader.helper";

export default {
  name: "selectPharmacy",
  data() {
    return {
      pharmacies: [],
    };
  },
  mounted() {
    this.getPharmacies();
  },
  methods: {
    getPharmacies() {
      loaderHelper.show("page");
      PharmacyService.getMyPharmacies()
        .then((result) => {
          this.pharmacies = result.data;
          loaderHelper.hide();
        })
        .catch(() => {
          loaderHelper.hide();
        });
    },
    select(pharmacy) {
      this.$store.dispatch(SELECT_PHARMACY, pharmacy);
      this.$router.push({ name: "dashboard" });
    },
    onLogout() {
      this.$store.dispatch(LOGOUT);
    },
  },
  computed: {},
};
</script>
